'use client';

import { ChannelTalk, hideChannelTalk } from '@/seo/ChannelTalk';
import { initChannelTalk } from '@/seo/ChannelTalkStore';
import { GoogleTagManager } from '@/seo/GoogleTagManager';
import { Hotjar } from '@/seo/Hotjar';
import { useSelectedLayoutSegments } from 'next/navigation';
import { useEffect } from 'react';

export const SEO = () => {
  const segments = useSelectedLayoutSegments();

  useEffect(() => {
    hideChannelTalk();
    const isInApp = segments[2] === '(breadcrumbs)' || segments[2] === 'record';
    if (isInApp) return; // workspace context에서 판단

    const isHomepage = segments[0] === '(homepage)';
    initChannelTalk(isHomepage); // 홈페이지에서 항상 노출
  }, [segments]);

  return (
    <>
      <GoogleTagManager gaId={process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_4_ID} />
      <Hotjar hotjarId={process.env.NEXT_PUBLIC_HOTJAR_ID} />
      <ChannelTalk />
    </>
  );
};
